import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import "./style.css";
import Header from './components/Header';
import About from './pages/About';
import WillowWeb from './pages/WillowWeb';
import Making, {loader as makingLoader} from './pages/Making.jsx';

const AppRouter = () => {

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Header />,
      errorElement: <Navigate to="/" />,
      children: [
        {
          errorElement: <Navigate to="/" />,
          children: [
            {
              path: "/bio",
              element: <About />
            },
            {
              path: "/willow-web",
              element: <WillowWeb />
            },
            {
              path: "/making/:work",
              element: <Making />,
              loader: makingLoader
            },
          ],
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

function App() {
  return (
    <AppRouter />
  );
}

export default App;